module.exports = __webpack_public_path__ + "static/media-card-6a90ee7cb2c06628538d8a96c8b311a1.png";